// import 'antd/dist/antd.css';
import 'antd/lib/button/style/css'
import 'antd/lib/input/style/css'
import 'antd/lib/form/style/css'
import 'antd/lib/modal/style/css'
import 'antd/lib/select/style/css';
import 'antd/lib/result/style/css';

import App from './components/app';

import { render } from "preact";

render(<App />, document.getElementById("sdm-contact-form"))

 //export default App;
